/** Outlook-friendly CTA snippet for layout wireframes (mirrors src/lib/email-design-rules.ts). */
export function bulletproofCtaHtml(
  label: string,
  href = '#',
  bgColor = '#e85d4c',
): string {
  return `<table border="0" cellspacing="0" cellpadding="0" role="presentation">
  <tr>
    <td align="center" bgcolor="${bgColor}" style="border-radius:8px;">
      <a href="${href}" target="_blank" style="display:inline-block;padding:14px 32px;font-size:16px;font-weight:600;color:#ffffff;text-decoration:none;border-radius:8px;background-color:${bgColor};min-height:44px;line-height:44px;box-sizing:border-box;">${label}</a>
    </td>
  </tr>
</table>`;
}
